module.exports = __webpack_public_path__ + "img/send_message.52f647f0.png";